// BOXEB2B — i18n translations (EN + FR). Simple flat map, no library.
export const TRANSLATIONS = {
    en: {
        nav: {
            features: "Features",
            pricing: "Pricing",
            faq: "FAQ",
            login: "Log in",
            register: "Start free",
            dashboard: "Dashboard",
            find: "Find",
            enrich: "Enrich",
            engage: "Engage",
            analyze: "Analyze",
            copilot: "AI Copilot",
            integrations: "Integrations",
            settings: "Settings",
            team: "Team",
            billing: "Credits & Billing",
            logout: "Log out",
        },
        landing: {
            eyebrow: "Sales intelligence · EU-first · pay-as-you-go",
            heroTitleA: "Find. Enrich.",
            heroTitleB: "Close.",
            heroSub: "The self-serve alternative to the $40k+ lead-gen agency. Prospect, enrich, and outreach B2B leads with an AI copilot that gets sharper every week.",
            heroCta: "Start free — 50 credits",
            heroSecondary: "See a live demo",
            heroBadge: "Built for PMEs, startups and SDRs — not enterprise procurement",
            trustedBy: "Powers pipeline for teams closing deals from Paris to Berlin",
            statsTitle: "Numbers our early users don't want us to publish",
            stats: {
                leads: { value: "42M+", label: "B2B contacts across EU" },
                emails: { value: "3.2×", label: "Reply rate vs cold list avg" },
                time: { value: "5 min", label: "From signup to first sequence" },
                credits: { value: "50", label: "Free credits, no card required" },
            },
            featuresTitle: "Four modules. One AI copilot. Zero seat lock-in.",
            featuresSub: "Everything the agencies charge $40k for — as a self-serve SaaS you can turn off next Tuesday.",
            features: [
                { key: "find", tag: "FIND", title: "AI Prospecting in plain English", body: "\"Find CTOs at 20–100 SaaS in Berlin funded in the last 18 months\" — get a curated list with map view, ICP scoring and one-click segments." },
                { key: "enrich", tag: "ENRICH", title: "Waterfall enrichment", body: "Emails, phones, LinkedIn, tech stack, intent signals. Pay only for what verifies. Full RGPD trail on every reveal." },
                { key: "engage", tag: "ENGAGE", title: "Sequences that write themselves", body: "AI drafts personalized emails per lead. Multi-step cadences, A/B tests, unified inbox and reply detection out of the box." },
                { key: "analyze", tag: "ANALYZE", title: "Revenue-grade analytics", body: "Funnel, ROI per campaign, cohort deliverability, exportable PDFs. No dashboards left behind." },
                { key: "copilot", tag: "COPILOT", title: "AI Sales Assistant everywhere", body: "CMD+K anywhere in the app — summarize a lead, rewrite an email, forecast a pipeline. Data stays yours." },
                { key: "credits", tag: "CREDITS", title: "Pay only for what you use", body: "1 credit reveals an email. 2 for a phone. 5 for full enrichment. No seat tax, no annual lock-in, no procurement calls." },
            ],
            pricingTitle: "One price for every stage. Move up when you're ready.",
            pricingSub: "No sales calls. No annual contract. Cancel or upgrade in one click.",
            pricingCta: "Get started",
            pricingCtaEnterprise: "Talk to us",
            pricingBadgePopular: "Most popular",
            pricingTiers: {
                free: { name: "Free", price: "€0", period: "forever", desc: "For anyone who wants to see what the agencies were hiding.", features: ["50 credits included", "Up to 100 leads", "1 user", "Community support"] },
                starter: { name: "Starter", price: "€49", period: "per month", desc: "For founders and lone SDRs closing their first 10 deals.", features: ["500 credits / month", "5,000 leads stored", "3 users", "Email + Chrome extension", "Standard support"] },
                growth: { name: "Growth", price: "€149", period: "per month", desc: "For teams past $10k MRR ready to scale outbound.", features: ["2,000 credits / month", "Unlimited leads", "10 users", "A/B testing + advanced analytics", "Priority support"] },
                enterprise: { name: "Enterprise", price: "€499", period: "per month", desc: "For agencies and 20+ person sales orgs.", features: ["Unlimited credits", "White-label available", "SSO + audit logs", "Dedicated CSM", "Custom onboarding"] },
            },
            testimonialsTitle: "What early operators are saying",
            testimonials: [
                { key: "1", name: "Amélie Rousseau", role: "Head of Growth, Kompanion", quote: "We killed a €2,400/month agency contract in week two. BOXEB2B books the same meetings for less than a Notion seat." },
                { key: "2", name: "Marek Novák", role: "Founder, Formia.io", quote: "Prospecting in natural language actually works. My cofounder went from 0 to 40 booked demos in a month." },
                { key: "3", name: "Sofia Bianchi", role: "SDR Lead, Northwave", quote: "The AI copilot rewrites my openers per lead. Reply rate went from 4% to 13% and my BDRs sound like humans again." },
            ],
            faqTitle: "Questions we actually get asked",
            faq: [
                { key: "1", q: "How is this different from an agency like UpscaleB2B?", a: "They charge €40k+ upfront and hand-hold. We're pay-as-you-go, self-serve, and the AI is your copilot instead of an account manager. You own the data, the sequences, and the inboxes." },
                { key: "2", q: "Is this RGPD-compliant?", a: "Yes. EU-first infrastructure, per-lead consent tracking, one-click export and deletion, full DPA available on Growth+." },
                { key: "3", q: "What are 'credits'?", a: "One unit of AI/data work. 1 credit reveals an email, 2 for a phone, 5 for full enrichment, 1 for an AI-generated email. Free plan gets 50 credits on signup." },
                { key: "4", q: "Can I bring my own inbox?", a: "Yes — Gmail and Outlook via OAuth on Starter+. Custom SMTP and mailbox warmup arrive Phase 6." },
                { key: "5", q: "Do you have a Chrome extension?", a: "Ships in Phase 8. It scrapes LinkedIn profiles in one click and pushes them straight into your BOXEB2B workspace." },
                { key: "6", q: "Can I export my data?", a: "Always. CSV export on every table, JSON export on the whole workspace, one-click GDPR erase. No hostage data." },
            ],
            ctaBigTitle: "50 credits. No card. 5-minute setup.",
            ctaBigSub: "You'll book your first meeting before your coffee gets cold.",
            ctaBigButton: "Start free — takes 60 seconds",
            footer: {
                tagline: "Find. Enrich. Close. — the sales intelligence stack for teams that don't have an RFP.",
                product: "Product",
                company: "Company",
                legal: "Legal",
                links: {
                    features: "Features",
                    pricing: "Pricing",
                    integrations: "Integrations",
                    roadmap: "Roadmap",
                    about: "About",
                    blog: "Blog",
                    contact: "Contact",
                    privacy: "Privacy",
                    terms: "Terms",
                    rgpd: "GDPR",
                    dpa: "DPA",
                },
                rights: "© 2026 BOXEB2B. Made in the EU.",
            },
        },
        auth: {
            loginTitle: "Welcome back",
            loginSub: "Sign in to keep your pipeline warm.",
            registerTitle: "Create your workspace",
            registerSub: "Free forever. 50 credits waiting on the other side.",
            name: "Full name",
            email: "Work email",
            password: "Password",
            passwordHint: "At least 8 characters",
            login: "Log in",
            register: "Create account",
            google: "Continue with Google",
            or: "or",
            noAccount: "No account yet?",
            hasAccount: "Already have an account?",
            createOne: "Create one",
            signIn: "Sign in",
            back: "Back to home",
            terms: "By continuing you agree to our Terms and Privacy Policy.",
        },
        app: {
            searchHint: "Search or run a command…",
            credits: "credits",
            welcomeBack: "Welcome back",
            dashboardTitle: "Dashboard",
            dashboardSub: "A daily read-out of your revenue engine.",
            widgetLeads: "Total leads",
            widgetCampaigns: "Active campaigns",
            widgetEmails: "Emails sent",
            widgetReply: "Reply rate",
            widgetCredits: "Credits remaining",
            aiInsightTitle: "AI insight of the day",
            aiInsightBody: "You have 0 active campaigns. Import your first list or run an AI prospecting query — I'll draft the first sequence.",
            weeklyActivity: "This week's activity",
            quickActions: "Quick actions",
            actionProspect: "Run AI prospecting",
            actionImport: "Import CSV",
            actionCampaign: "New campaign",
            actionCopilot: "Ask AI copilot",
            stubTitle: (m) => `${m} — coming online`,
            stubBody: "This module ships in the next build. Phase 1 lays the foundation — auth, shell and dashboard skeleton. Modules unlock progressively from Phase 2.",
        },
        cmdk: {
            heading: "Navigation",
            actions: "Actions",
            help: "Help",
            empty: "No results found.",
        },
    },
    fr: {
        nav: {
            features: "Fonctionnalités",
            pricing: "Tarifs",
            faq: "FAQ",
            login: "Connexion",
            register: "Essayer gratuit",
            dashboard: "Tableau de bord",
            find: "Trouver",
            enrich: "Enrichir",
            engage: "Engager",
            analyze: "Analyser",
            copilot: "Copilote IA",
            integrations: "Intégrations",
            settings: "Paramètres",
            team: "Équipe",
            billing: "Crédits & Facturation",
            logout: "Se déconnecter",
        },
        landing: {
            eyebrow: "Sales intelligence · Made in EU · à l'usage",
            heroTitleA: "Trouve. Enrichis.",
            heroTitleB: "Signe.",
            heroSub: "L'alternative self-serve à l'agence de lead gen à 40k€. Prospecter, enrichir et outreach B2B avec un copilote IA qui apprend chaque semaine.",
            heroCta: "Commencer — 50 crédits offerts",
            heroSecondary: "Voir une démo live",
            heroBadge: "Pensé pour PME, startups et SDRs — pas pour les DSI",
            trustedBy: "Utilisé par des équipes qui signent de Paris à Berlin",
            statsTitle: "Les chiffres que nos early users préfèreraient qu'on cache",
            stats: {
                leads: { value: "42M+", label: "Contacts B2B en Europe" },
                emails: { value: "3,2×", label: "Taux de réponse vs cold list" },
                time: { value: "5 min", label: "De l'inscription au 1er envoi" },
                credits: { value: "50", label: "Crédits gratuits, sans CB" },
            },
            featuresTitle: "Quatre modules. Un copilote IA. Zéro engagement.",
            featuresSub: "Tout ce que les agences facturent 40k€ — en SaaS que tu peux couper mardi prochain.",
            features: [
                { key: "find", tag: "FIND", title: "Prospection IA en langage naturel", body: "\"Trouve-moi les CTO de SaaS 20-100 personnes à Berlin financés depuis 18 mois\" — liste curée, vue carte, scoring ICP et segments en un clic." },
                { key: "enrich", tag: "ENRICH", title: "Enrichissement en waterfall", body: "Emails, téléphones, LinkedIn, tech stack, intent signals. Tu paies seulement ce qui est vérifié. Traçabilité RGPD complète." },
                { key: "engage", tag: "ENGAGE", title: "Séquences qui s'écrivent seules", body: "L'IA rédige un email personnalisé par lead. Cadences multi-steps, A/B tests, inbox unifiée et détection de réponse." },
                { key: "analyze", tag: "ANALYZE", title: "Analytics grade revenue", body: "Funnel, ROI par campagne, cohortes de délivrabilité, exports PDF. Aucun dashboard n'est laissé pour compte." },
                { key: "copilot", tag: "COPILOT", title: "Copilote IA partout", body: "CMD+K depuis n'importe où — résume un lead, réécris un email, prévois un pipeline. La donnée reste chez toi." },
                { key: "credits", tag: "CREDITS", title: "Tu paies ce que tu consommes", body: "1 crédit = un email. 2 = un téléphone. 5 = enrichissement complet. Pas de licence par siège, pas d'engagement annuel." },
            ],
            pricingTitle: "Un prix pour chaque étape. Change quand tu veux.",
            pricingSub: "Pas d'appel commercial. Pas d'engagement annuel. Annulation ou upgrade en un clic.",
            pricingCta: "C'est parti",
            pricingCtaEnterprise: "Nous parler",
            pricingBadgePopular: "Le plus choisi",
            pricingTiers: {
                free: { name: "Free", price: "0 €", period: "à vie", desc: "Pour ceux qui veulent voir ce que les agences cachaient.", features: ["50 crédits inclus", "Jusqu'à 100 leads", "1 utilisateur", "Support communautaire"] },
                starter: { name: "Starter", price: "49 €", period: "par mois", desc: "Pour founders et SDRs solos qui closent leurs 10 premiers deals.", features: ["500 crédits / mois", "5 000 leads stockés", "3 utilisateurs", "Email + extension Chrome", "Support standard"] },
                growth: { name: "Growth", price: "149 €", period: "par mois", desc: "Pour les équipes qui passent 10k€ MRR et scale l'outbound.", features: ["2 000 crédits / mois", "Leads illimités", "10 utilisateurs", "A/B testing + analytics avancés", "Support prioritaire"] },
                enterprise: { name: "Enterprise", price: "499 €", period: "par mois", desc: "Pour les agences et les équipes sales de 20+.", features: ["Crédits illimités", "White-label dispo", "SSO + logs d'audit", "CSM dédié", "Onboarding sur mesure"] },
            },
            testimonialsTitle: "Ce qu'en disent les premiers utilisateurs",
            testimonials: [
                { key: "1", name: "Amélie Rousseau", role: "Head of Growth, Kompanion", quote: "On a coupé un contrat d'agence à 2 400€/mois en semaine 2. BOXEB2B book les mêmes RDV pour moins qu'une licence Notion." },
                { key: "2", name: "Marek Novák", role: "Founder, Formia.io", quote: "La prospection en langage naturel marche vraiment. Mon cofondateur est passé de 0 à 40 démos bookées en un mois." },
                { key: "3", name: "Sofia Bianchi", role: "SDR Lead, Northwave", quote: "Le copilote IA réécrit mes openers par lead. Taux de réponse passé de 4% à 13% et mes BDRs sonnent enfin comme des humains." },
            ],
            faqTitle: "Les questions qu'on nous pose vraiment",
            faq: [
                { key: "1", q: "En quoi c'est différent d'une agence comme UpscaleB2B ?", a: "Elles facturent 40k€+ à l'avance et te tiennent la main. Nous : à l'usage, self-serve, l'IA est ton copilote au lieu d'un account manager. Tu gardes la data, les séquences et les inboxes." },
                { key: "2", q: "C'est RGPD-compliant ?", a: "Oui. Infra EU, consentement tracké par lead, export/suppression en un clic, DPA disponible dès Growth." },
                { key: "3", q: "C'est quoi les 'crédits' ?", a: "Une unité de travail IA/data. 1 crédit = un email révélé, 2 = un téléphone, 5 = enrichissement complet, 1 = un email généré IA. Free plan démarre à 50 crédits." },
                { key: "4", q: "Je peux utiliser ma propre inbox ?", a: "Oui — Gmail et Outlook via OAuth dès Starter. SMTP custom et warmup dès la Phase 6." },
                { key: "5", q: "Vous avez une extension Chrome ?", a: "Elle arrive en Phase 8. Un clic pour scraper un profil LinkedIn dans ton workspace." },
                { key: "6", q: "Je peux exporter ma data ?", a: "Toujours. Export CSV sur chaque table, JSON global, effacement RGPD en un clic. Zéro data hostage." },
            ],
            ctaBigTitle: "50 crédits. Sans CB. Setup 5 minutes.",
            ctaBigSub: "Tu bookes ton premier RDV avant que ton café refroidisse.",
            ctaBigButton: "Commencer — 60 secondes",
            footer: {
                tagline: "Trouve. Enrichis. Signe. — la stack sales intelligence pour ceux qui n'ont pas de RFP.",
                product: "Produit",
                company: "Société",
                legal: "Légal",
                links: {
                    features: "Fonctionnalités",
                    pricing: "Tarifs",
                    integrations: "Intégrations",
                    roadmap: "Roadmap",
                    about: "À propos",
                    blog: "Blog",
                    contact: "Contact",
                    privacy: "Confidentialité",
                    terms: "Conditions",
                    rgpd: "RGPD",
                    dpa: "DPA",
                },
                rights: "© 2026 BOXEB2B. Made in EU.",
            },
        },
        auth: {
            loginTitle: "Content de te revoir",
            loginSub: "Connecte-toi pour garder ton pipeline chaud.",
            registerTitle: "Crée ton workspace",
            registerSub: "Gratuit à vie. 50 crédits t'attendent de l'autre côté.",
            name: "Nom complet",
            email: "Email pro",
            password: "Mot de passe",
            passwordHint: "8 caractères minimum",
            login: "Connexion",
            register: "Créer un compte",
            google: "Continuer avec Google",
            or: "ou",
            noAccount: "Pas encore de compte ?",
            hasAccount: "Déjà un compte ?",
            createOne: "En créer un",
            signIn: "Se connecter",
            back: "Retour à l'accueil",
            terms: "En continuant tu acceptes nos CGU et notre Politique de confidentialité.",
        },
        app: {
            searchHint: "Rechercher ou lancer une commande…",
            credits: "crédits",
            welcomeBack: "Bon retour",
            dashboardTitle: "Tableau de bord",
            dashboardSub: "Le rapport quotidien de ta machine à revenus.",
            widgetLeads: "Leads totaux",
            widgetCampaigns: "Campagnes actives",
            widgetEmails: "Emails envoyés",
            widgetReply: "Taux de réponse",
            widgetCredits: "Crédits restants",
            aiInsightTitle: "Insight IA du jour",
            aiInsightBody: "Tu as 0 campagne active. Importe ta première liste ou lance une prospection IA — je t'écris la première séquence.",
            weeklyActivity: "Activité de la semaine",
            quickActions: "Actions rapides",
            actionProspect: "Prospection IA",
            actionImport: "Importer un CSV",
            actionCampaign: "Nouvelle campagne",
            actionCopilot: "Copilote IA",
            stubTitle: (m) => `${m} — bientôt en ligne`,
            stubBody: "Ce module arrive dans la prochaine build. La Phase 1 pose les fondations — auth, shell et dashboard. Les modules s'ouvrent progressivement dès la Phase 2.",
        },
        cmdk: {
            heading: "Navigation",
            actions: "Actions",
            help: "Aide",
            empty: "Aucun résultat.",
        },
    },
};
